export const messages = {
  en: {
    storehouseManage: {
      searchTitle: 'Query Conditions',
      listTitle: 'Warehouse Information',
      placeholders: {
        shName: 'Please enter warehouse name',
        shId: 'Please enter warehouse ID',
        isShow: 'Please select whether it is open to the public',
        shDesc: 'Please enter warehouse description',
        selectFlow: 'Please select flow'
      },
      options: {
        all: 'All',
        yes: 'Yes',
        no: 'No',
        noAudit: 'No audit'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        detail: 'Details'
      },
      table: {
        shId: 'Warehouse ID',
        shName: 'Warehouse Name',
        isShow: 'Open to Public',
        allowPurchase: 'Allow Purchase',
        allowUse: 'Allow Use',
        purchaseSwitch: 'Purchase Audit',
        useSwitch: 'Use Audit',
        allocationSwitch: 'Allocation Audit',
        createTime: 'Creation Time',
        shDesc: 'Description',
        operations: 'Operations'
      },
      messages: {
        fetchError: 'Failed to fetch warehouse data'
      }
    }
  },
  zh: {
    storehouseManage: {
      searchTitle: '查询条件',
      listTitle: '仓库信息',
      placeholders: {
        shName: '请输入仓库名称',
        shId: '请输入仓库编号',
        isShow: '请选择是否对外开放',
        shDesc: '请输入仓库描述',
        selectFlow: '请选择流程'
      },
      options: {
        all: '全部',
        yes: '是',
        no: '否',
        noAudit: '不审核'
      },
      buttons: {
        search: '查询',
        reset: '重置',
        add: '添加',
        edit: '修改',
        delete: '删除',
        detail: '详情'
      },
      table: {
        shId: '仓库编号',
        shName: '仓库名称',
        isShow: '对外开放',
        allowPurchase: '允许采购',
        allowUse: '允许领用',
        purchaseSwitch: '采购审核',
        useSwitch: '领用审核',
        allocationSwitch: '调拨审核',
        createTime: '创建时间',
        shDesc: '描述',
        operations: '操作'
      },
      messages: {
fetchError: '获取仓库数据失败'
    }
  },
  'zh-TW': {
    storehouseManage: {
      searchTitle: '查詢條件',
      listTitle: '倉庫信息',
      placeholders: {
        shName: '請輸入倉庫名稱',
        shId: '請輸入倉庫編號',
        isShow: '請選擇是否對外開放',
        shDesc: '請輸入倉庫描述',
        selectFlow: '請選擇流程'
      },
      options: {
        all: '全部',
        yes: '是',
        no: '否',
        noAudit: '不審核'
      },
      buttons: {
        search: '查詢',
        reset: '重置',
        add: '添加',
        edit: '修改',
        delete: '刪除',
        detail: '詳情'
      },
      table: {
        shId: '倉庫編號',
        shName: '倉庫名稱',
        isShow: '對外開放',
        allowPurchase: '允許採購',
        allowUse: '允許領用',
        purchaseSwitch: '採購審核',
        useSwitch: '領用審核',
        allocationSwitch: '調撥審核',
        createTime: '創建時間',
        shDesc: '描述',
        operations: '操作'
      },
      messages: {
        fetchError: '獲取倉庫數據失敗'
      }
    }
  }
}
}